import React, { Fragment, useState } from 'react';

import { Button } from '@mui/material';

import { Box, Tab, Tabs, Tooltip } from "@mui/material";
import SelectDateRange from '../../components/SelectDateRange';
import SelectMakes from '../../components/SelectMakes';
import SelectMessageBody from '../../components/SelectMessageBody';
import SelectModels from '../../components/SelectModels';
import SelectTitle from '../../components/SelectTitle';
import SelectURL from '../../components/SelectURL';
import SelectYears from '../../components/SelectYears';
import ICampaign from '../../shared/ICampaign';
import IData from '../../shared/IData';
import IMake from '../../shared/IMake';
import IModel from '../../shared/IModel';
import IState from '../../shared/IState';
import BillingAddress from '../BillingAddress/BillingAddress';
import GeoFence from '../GeoFence/GeoFence';

import Styles from '../../lib/Styles';
import classes from './Add.module.scss';
import SelectVINs from '../../components/SelectVINs/SelectVINs';
import AlertDialog from '../../components/AlertDialog';
import { AlertDialogContent } from '../table/EnhancedTable';

function a11yProps(index: number) {
  return {
    id: `tab-${index}`,
    'aria-controls': `tabpanel-${index}`,
  };
}

export interface IAddProps {
  setIsPaneOpen: Function;
  handleSave: Function;
  setShowCancelCreateAlert: Function;
  readOnly: boolean;
  data: IData | undefined;
}

export default function Add(props: IAddProps) {
  const { setIsPaneOpen, handleSave, setShowCancelCreateAlert, readOnly, data } = props;
  const cx = new Styles(classes).cx;

  const [selectedMakes, setSelectedMakes] = useState<Array<IMake>>([]);
  const [selectedModels, setSelectedModels] = useState<Array<IModel>>([]);
  const [selectedYears, setSelectedYears] = useState<Array<Number>>([]);
  const [selectedUSStates, setSelectedUSStates] = useState<Array<IState>>([]);
  const [selectedUSState, setSelectedUSState] = useState<IState>();
  const [selectedStreet, setSelectedStreet] = useState<string>("");
  const [selectedCity, setSelectedCity] = useState<string>("");
  const [selectedZipCodes, setSelectedZipCodes] = useState<string>();
  const [selectedZipCode, setSelectedZipCode] = useState<string>("");
  const [selectedRegisteredAfterDate, setSelectedRegisteredAfterDate] = useState<Date | null>(null);
  const [selectedRegisteredBeforeDate, setSelectedRegisteredBeforeDate] = useState<Date | null>(null);
  const [dateRangeError, setDateRangeError] = useState<boolean>(false);
  const [registeredAfterDateError, setRegisteredAfterDateError] = useState<boolean>(false);
  const [registeredBeforeDateError, setRegisteredBeforeDateError] = useState<boolean>(false);
  const [selectedTitle, setSelectedTitle] = useState<string>("");
  const [selectedMessageBody, setSelectedMessageBody] = useState<string>("");
  const [selectedURL, setSelectedURL] = useState<string>("");
  const [urlError, setURLError] = useState<boolean>(false);
  const [isDirty, setIsDirty] = useState<boolean>(false);

  const [selectedDistance, setSelectedDistance] = useState<{ value: string, zoom: string } | undefined>();
  const [selectedLatitude, setSelectedLatitude] = useState<string | undefined>();
  const [selectedLongitude, setSelectedLongitude] = useState<string | undefined>();

  const [geoFenceHasEmptyRequiredFields, setGeoFenceHasEmptyRequiredFields] = useState<boolean>(false);

  const [billingAddressError, setBillingAddressError] = useState<boolean>(false);
  const [geoFenceError, setGeoFenceError] = useState<boolean>(false);

  const [selectedVINDescription, setSelectedVINDescription] = useState<string>('');
  const [selectedVINFileName, setSelectedVINFileName] = useState<string>('');
  const [selectedVINFileGUID, setSelectedVINFileGUID] = useState<string>('');

  const [bypassUserNotificationOptOut, setBypassUserNotificationOptOut] = useState<boolean>(false);

  const [listOfWMIs, setListOfWMIs] = useState<string>('');

  const [selectedTab, setSelectedTab] = useState((!!data?.vinTargetsClaimCheckIdentifier) ? 1 : 0);

  const [alertDialogContent, setAlertDialogContent] = useState<AlertDialogContent>();
  const [showAlert, setShowAlert] = useState<boolean>(false);

  const hasData = (property: [] | string | object | undefined | null) => {
    if (typeof property === 'string') {
      return !!property && (property.length > 0);
    } else if (Array.isArray(property)) {
      return property.length > 0;
    } else if (property instanceof Date) {
      return true;
    } else if (typeof property === 'object') {
      return !!property;
    }
    return false;
  }

  /**
   * If the user wants to switch how they target a campaign (by switching tabs) and the current tab has selection data entered then
   * ask the user if they wish to proceed.  The selection data will be cleared out when the switching to the other tab.
   */
  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    let tabHasData = false;

    if (newValue === 1) {
      tabHasData ||= hasData(selectedMakes);
      tabHasData ||= hasData(selectedModels);
      tabHasData ||= hasData(selectedYears);
      tabHasData ||= hasData(selectedUSStates);
      tabHasData ||= hasData(selectedZipCodes);
      tabHasData ||= hasData(selectedStreet);
      tabHasData ||= hasData(selectedCity);
      tabHasData ||= hasData(selectedUSState);
      tabHasData ||= hasData(selectedZipCode);
      tabHasData ||= hasData(selectedLatitude);
      tabHasData ||= hasData(selectedLongitude);
      tabHasData ||= hasData(selectedDistance);
      tabHasData ||= hasData(selectedRegisteredAfterDate);
      tabHasData ||= hasData(selectedRegisteredBeforeDate);
    } else {
      tabHasData ||= hasData(selectedVINFileName);
      tabHasData ||= hasData(selectedVINFileGUID);
      tabHasData ||= hasData(selectedVINDescription);
      tabHasData ||= bypassUserNotificationOptOut;
    }

    if (tabHasData) {
      setAlertDialogContent({
        title: 'Switching campaign selection criteria.',
        body: (<>Current selection settings will be cleared.<br /><br />Are you sure you want to switch tabs?</>),
        yesText: 'Yes',
        noText: 'No',
        yesCallback: () => {
          setShowAlert(false);

          if (newValue === 1) {
            setSelectedYears([]);
            setSelectedModels([]);
            setSelectedMakes([]);
            setSelectedUSStates([]);
            setSelectedZipCodes(undefined);
            setSelectedZipCode('');
            setSelectedStreet('');
            setSelectedCity('');
            setSelectedUSState(undefined);
            setSelectedLatitude(undefined);
            setSelectedLongitude(undefined);
            setSelectedDistance(undefined);
            setSelectedRegisteredAfterDate(null);
            setSelectedRegisteredBeforeDate(null);
            setBypassUserNotificationOptOut(false);
          } else {
            setSelectedVINFileName('');
            setSelectedVINFileGUID('');
            setSelectedVINDescription('');
            setListOfWMIs('');
            setBypassUserNotificationOptOut(false);
          }

          setSelectedTab(newValue);
        },
        noCallback: () => setShowAlert(false)
      });
      setShowAlert(true);
    } else {
      setSelectedTab(newValue);
    }
  };

  const onChangeMakes = () => {
    setSelectedModels([]);
    setIsDirty(true);
  }
  const onChangeModels = () => {
    setSelectedYears([]);
    setIsDirty(true);
  }

  function getISO(date: Date | null): string {
    let iso: string = 'error';

    if (!date) {
      iso = '';
    } else {
      try {
        iso = date.toISOString();
      }
      catch {
        console.log('Unable to parse the date into iso string.');
      }
    }
    return iso;
  }

  let registeredAfterDate: string | undefined = getISO(selectedRegisteredAfterDate);
  let registeredBeforeDate: string | undefined = getISO(selectedRegisteredBeforeDate);

  const cancel = () => {
    // TODO: Update how each field detects changes.  Currently the onChange handlers are called during initialization.
    // Therefore isDirty is always true.
    if (readOnly) {
      handleCancel();
    } else if (isDirty) {
      setShowCancelCreateAlert(true);
    } else {
      handleCancel();
    }
  }

  const handleCancel = () => {
    setIsPaneOpen(false);
    setIsDirty(false);
  }

  const isNumeric = (n: any) => {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  const save = () => {
    let zips = selectedZipCodes ? selectedZipCodes.replace(/, /g, ' ') : '';

    const longitude: string = (!!selectedLongitude) ? selectedLongitude : '';
    const latitude: string = (!!selectedLatitude) ? selectedLatitude : '';
    const distance: string = (!!selectedDistance) ? selectedDistance.value : '';

    let campaign: ICampaign = {
      makes: selectedMakes.sort((a, b) => a.Name.localeCompare(b.Name)),
      models: selectedModels.sort((a, b) => a.Name.localeCompare(b.Name)),
      geoFenceState: selectedUSState,
      geoFenceStreetAddress: selectedStreet,
      geoFenceCity: selectedCity,
      years: selectedYears.sort((a, b) => a.valueOf() - b.valueOf()),
      states: selectedUSStates.sort((a, b) => a.name.localeCompare(b.name)),
      zipCodes: zips.split(' ').sort().toString().replace(/,/g, ' '),
      geoFenceZipCode: selectedZipCode,
      geoFenceRadiusInMiles: isNumeric(distance) ? Number.parseFloat(distance) : undefined,
      geoFenceLatitude: isNumeric(latitude) ? Number.parseFloat(latitude) : undefined,
      geoFenceLongitude: isNumeric(longitude) ? Number.parseFloat(longitude) : undefined,
      registeredAfterDate: registeredAfterDate,
      registeredBeforeDate: registeredBeforeDate,
      title: selectedTitle,
      messageBody: selectedMessageBody,
      url: selectedURL,
      submittingUser: "",
      createdDateTime: data ? data.createdDateTime : "",
      submittedDateTime: data ? data.submittedDateTime : "",
      scheduledDateTime: data ? data.scheduledDateTime : "",
      id: data ? data.id : "",

      vinTargetsOriginalFileName: selectedVINFileName,
      vinTargetsClaimCheckIdentifier: selectedVINFileGUID,
      vinTargetsDescription: selectedVINDescription,
      bypassUserNotificationOptOut: bypassUserNotificationOptOut
    }
    handleSave(campaign);
  }

  const hasInvalidSettings = () => {
    let disabled: boolean;

    if (selectedTab === 1) {
      disabled = !selectedVINFileGUID ||
        !selectedVINDescription ||
        !selectedMessageBody ||
        !selectedTitle ||
        urlError;
    } else {
      disabled = selectedMakes.length === 0 ||
        !selectedMessageBody ||
        !selectedTitle ||
        dateRangeError ||
        urlError ||
        billingAddressError ||
        geoFenceError || geoFenceHasEmptyRequiredFields;
    }
    return disabled;
  }

  return (
    <Fragment>
      <div className={cx('tabs')}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', paddingTop: 0 }} >
          <Tabs value={selectedTab} onChange={handleChangeTab} aria-label="Select Target Criteria">
            <Tooltip title='Target by: Make, Model, Year - Billing Address - Geo Fencing - Dates' enterDelay={1000} arrow>
              <Tab label="Detailed Selection Criteria" {...a11yProps(0)} />
            </Tooltip>
            <Tooltip title='Target by: Vehicle Identification Number' enterDelay={1000} arrow>
              <Tab label='VIN'  {...a11yProps(1)} ></Tab>
            </Tooltip>
          </Tabs>
        </Box>
      </div>
      <>
        <div className={cx((selectedTab !== 0) ? 'hidden' : 'visible')}>
          <SelectMakes initialValue={data?.makes}
            selectedMakes={selectedMakes}
            setSelectedMakes={setSelectedMakes}
            onChangeMakes={onChangeMakes}
            readOnly={readOnly} />
          <SelectModels initialValue={data?.models}
            selectedMakes={selectedMakes}
            selectedModels={selectedModels}
            setSelectedModels={setSelectedModels}
            onChangeModels={onChangeModels}
            readOnly={readOnly} />
          <SelectYears initialValue={data?.years}
            selectedMakes={selectedMakes}
            selectedModels={selectedModels}
            selectedYears={selectedYears}
            setSelectedYears={setSelectedYears}
            onChangeYears={() => setIsDirty(true)}
            readOnly={readOnly} />
          <BillingAddress data={data} readOnly={readOnly} setError={setBillingAddressError} setIsDirty={setIsDirty}
            setSelectedUSStates={setSelectedUSStates} selectedUSStates={selectedUSStates}
            setSelectedZipCodes={setSelectedZipCodes} selectedZipCodes={selectedZipCodes} />
          <GeoFence data={data} readOnly={readOnly} hasFetchGeoButton={true} setError={setGeoFenceError} setIsDirty={setIsDirty} setHasEmptyRequiredFields={setGeoFenceHasEmptyRequiredFields}
            selectedStreet={selectedStreet} setSelectedStreet={setSelectedStreet}
            selectedCity={selectedCity} setSelectedCity={setSelectedCity}
            selectedUSState={selectedUSState} setSelectedUSState={setSelectedUSState}
            selectedZipCode={selectedZipCode} setSelectedZipCode={setSelectedZipCode}
            selectedLatitude={selectedLatitude} setSelectedLatitude={setSelectedLatitude}
            selectedLongitude={selectedLongitude} setSelectedLongitude={setSelectedLongitude}
            selectedDistance={selectedDistance} setSelectedDistance={setSelectedDistance} />
          <SelectDateRange initialValue={{ registeredAfterDate: data?.registeredAfterDate, registeredBeforeDate: data?.registeredBeforeDate }}
            selectedRegisteredAfterDate={selectedRegisteredAfterDate}
            selectedRegisteredBeforeDate={selectedRegisteredBeforeDate}
            setSelectedRegisteredAfterDate={setSelectedRegisteredAfterDate}
            setSelectedRegisteredBeforeDate={setSelectedRegisteredBeforeDate}
            dateRangeError={dateRangeError}
            setDateRangeError={setDateRangeError}
            registeredAfterDateError={registeredAfterDateError}
            setRegisteredAfterDateError={setRegisteredAfterDateError}
            registeredBeforeDateError={registeredBeforeDateError}
            setRegisteredBeforeDateError={setRegisteredBeforeDateError}
            readOnly={readOnly} />
        </div>
        <div className={cx((selectedTab === 0) ? 'hidden' : 'visible')}>
          <SelectVINs
            initialVINFileName={data?.vinTargetsOriginalFileName}
            selectedVINFileName={selectedVINFileName}
            setSelectedVINFileName={setSelectedVINFileName}
            initialVINDescription={data?.vinTargetsDescription}
            selectedVINDescription={selectedVINDescription}
            setSelectedVINDescription={setSelectedVINDescription}
            initialVINFileGUID={data?.vinTargetsClaimCheckIdentifier}
            selectedVINFileGUID={selectedVINFileGUID}
            setSelectedVINFileGUID={setSelectedVINFileGUID}
            initialBypassUserNotificationOptOut={(data?.bypassUserNotificationOptOut === undefined) ? false : data.bypassUserNotificationOptOut}
            bypassUserNotificationOptOut={bypassUserNotificationOptOut}
            setBypassUserNotificationOptOut={setBypassUserNotificationOptOut}
            listOfWMIs={listOfWMIs}
            setListOfWMIs={setListOfWMIs}
            onChange={() => setIsDirty(true)}
            readOnly={readOnly}
          />
        </div>
      </>

      <div className={cx('line')} />

      <SelectTitle initialValue={data?.title}
        selectedTitle={selectedTitle}
        setSelectedTitle={setSelectedTitle}
        onChangeTitle={() => setIsDirty(true)}
        readOnly={readOnly} />
      <SelectMessageBody initialValue={data?.messageBody}
        selectedMessageBody={selectedMessageBody}
        setSelectedMessageBody={setSelectedMessageBody}
        onChangeMessageBody={() => setIsDirty(true)}
        readOnly={readOnly} />
      <SelectURL initialValue={data?.url}
        selectedURL={selectedURL}
        setSelectedURL={setSelectedURL}
        onChangeURL={() => setIsDirty(true)}
        urlError={urlError}
        setURLError={setURLError}
        readOnly={readOnly} />

      {readOnly ? (
        <>

          <div className={cx('button-div')}>
            <span className="cancel-button">
              <Button variant="contained" onClick={cancel}>Close</Button>
            </span>
          </div>
          <br />
        </>
      ) : (
        <div className={cx('button-div')} >
          <span className={cx('save-button')}>
            <Button variant="contained" onClick={save} disabled={hasInvalidSettings()}>
              Save
            </Button>
          </span>
          <span className={cx('cancel-button')}>
            <Button variant="contained" onClick={cancel}>Cancel</Button>
          </span>
          <br />
        </div>
      )}

      <AlertDialog showAlert={showAlert}
        setShowAlert={setShowAlert}
        title={alertDialogContent?.title ? alertDialogContent?.title : ''}
        body={alertDialogContent?.body ? alertDialogContent?.body : ''}
        agree={alertDialogContent?.yesText ? alertDialogContent?.yesText : ''}
        disagree={alertDialogContent?.noText ? alertDialogContent?.noText : ''}
        handleAgree={() => {
          setShowAlert(false);
          alertDialogContent?.yesCallback(true);
        }}
        handleDisagree={() => {
          setShowAlert(false);
          alertDialogContent?.noCallback(false);
        }} />

    </Fragment>
  );
};
